module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "swiper-ocean-container",
      "data-type": "layout"
    }
  }, [_c('swiper', {
    ref: "problemsOcean",
    staticClass: "span-swiper span-swiper-full span-full full-transitions bgblue",
    attrs: {
      "id": "swiper-ocean",
      "options": _vm.swiperOption
    }
  }, [_c('swiper-slide', [_c('div', {
    staticClass: "full-inner"
  }, [_c('h2', {
    staticClass: "full-title content-650"
  }, [_vm._v(_vm._s(_vm.title))])])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "full-inner content-750"
  }, [_c('h3', {
    staticClass: "full-title white"
  }, [_vm._v(_vm._s(_vm.slider[0].title))]), _vm._v(" "), _c('div', {
    staticClass: "entry-content pt3",
    domProps: {
      "innerHTML": _vm._s(_vm.slider[0].content)
    }
  })])]), _vm._v(" "), _c('swiper-slide', [_c('div', {
    staticClass: "full-inner content-750"
  }, [_c('h3', {
    staticClass: "full-title white"
  }, [_vm._v(_vm._s(_vm.slider[1].title))]), _vm._v(" "), _c('div', {
    staticClass: "entry-content pt3",
    domProps: {
      "innerHTML": _vm._s(_vm.slider[1].content)
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-prev",
    slot: "button-prev"
  }), _vm._v(" "), _c('div', {
    staticClass: "swiper-button-next",
    slot: "button-next"
  })], 1), _vm._v(" "), _c('ul', {
    staticClass: "scene",
    attrs: {
      "id": "scene",
      "data-friction-x": "0.1",
      "data-friction-y": "0.1",
      "data-scalar-x": "4"
    }
  }, [_c('li', {
    staticClass: "layer turtle",
    attrs: {
      "data-depth": "0.30"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-turtle.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish1",
    attrs: {
      "data-depth": "-0.50"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish1.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer bottle",
    attrs: {
      "data-depth": "0.40"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-bottle.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish2",
    attrs: {
      "data-depth": "0.60"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish2.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish3",
    attrs: {
      "data-depth": "0.80"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish3.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer bag",
    attrs: {
      "data-depth": "-0.90"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-bag.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fork",
    attrs: {
      "data-depth": "0.70"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 1
    },
    attrs: {
      "src": "/static/images/problems-ocean-fork.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish4",
    attrs: {
      "data-depth": "0.30"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish3.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish5",
    attrs: {
      "data-depth": "0.30"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish1.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish6",
    attrs: {
      "data-depth": "0.30"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish4.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fish7",
    attrs: {
      "data-depth": "0.30"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-fish5.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer bottle2",
    attrs: {
      "data-depth": "0.40"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-bottle.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer bottle3",
    attrs: {
      "data-depth": "-0.40"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-bottle.svg"
    }
  })]), _vm._v(" "), _c('li', {
    staticClass: "layer fork2",
    attrs: {
      "data-depth": "0.70"
    }
  }, [_c('img', {
    class: {
      'active': _vm.swiperOption.currentSlide == 2
    },
    attrs: {
      "src": "/static/images/problems-ocean-fork.svg"
    }
  })])]), _vm._v(" "), _c('canvas', {
    attrs: {
      "id": "bubbles"
    }
  }), _vm._v(" "), _vm._m(0)], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "read-more",
    attrs: {
      "href": "#",
      "data-index": "1"
    }
  }, [_c('span', {
    staticClass: "arrow-down"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5e3df664!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Problems-ocean.vue
// module id = 162
// module chunks = 1